import { render, staticRenderFns } from "./soon.vue?vue&type=template&id=62d1580a&"
import script from "./soon.vue?vue&type=script&lang=js&"
export * from "./soon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports